export default "__VITE_ASSET__YgbMFXKw__"